import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { DATA_LOOKUP_LEVEL_ACTION_TYPE } from "./data-lookup-level.action";
import { DataLookUpLevel, DataLookUpState } from "./data-lookup-level.model";

const INITIAL_STATE: DataLookUpState = {
	informationLevel: undefined,
};

export function dataLookupLevelReducer(state = INITIAL_STATE, action: ActionWithPayload): DataLookUpState {
	switch (action.type) {
		case DATA_LOOKUP_LEVEL_ACTION_TYPE.getDataLookupLevel: {
			return updateState(state, {
				informationLevel: undefined,
			});
		}

		case DATA_LOOKUP_LEVEL_ACTION_TYPE.resetState: {
			return INITIAL_STATE;
		}

		case DATA_LOOKUP_LEVEL_ACTION_TYPE.getDataLookupLevelSuccess: {
			return updateState(state, {
				informationLevel: action.payload.informationLevel,
			});
		}

		case DATA_LOOKUP_LEVEL_ACTION_TYPE.getDataLookupLevelFail: {
			return updateState(state, {
				informationLevel: DataLookUpLevel.NoData,
			});
		}

		default:
			return state;
	}
}
